// ================================================================================================
// Controller for the site footer
// ================================================================================================

import '../scss/footer.scss';

const DEBUG_VERBOSE = false;
const LOG_PREFIX = `[BreakpointWidgetController]`;

enum CSSStylePropertyHelper {
	ScrollbarWidth = '--scrollbar-width',

	ViewportWidth = '--viewport-width',
	ViewportHeight = '--viewport-height',
	ViewportAspectRatio = '--viewport-aspect-ratio',

	// For helper tool
	HelperViewportWidth = '--helper-viewport-width',
	HelperViewportHeight = '--helper-viewport-height',
	HelperViewportAspectRatio = '--helper-viewport-aspect-ratio',
}

class BreakpointWidgetController {
	constructor() {}

	init() {
		DEBUG_VERBOSE && console.log(LOG_PREFIX);

		const resizeObserver = new ResizeObserver(() => {
			document.documentElement.style.setProperty(CSSStylePropertyHelper.ViewportWidth, `${window.innerWidth}`);
			document.documentElement.style.setProperty(CSSStylePropertyHelper.ViewportHeight, `${window.innerHeight}`);

			const aspectRatio = window.innerWidth / window.innerHeight;

			// Don't want ratio going below 1
			document.documentElement.style.setProperty(CSSStylePropertyHelper.ViewportAspectRatio, `${Math.max(1, aspectRatio)}`);

			// For helper
			document.documentElement.style.setProperty(CSSStylePropertyHelper.HelperViewportWidth, `"${window.innerWidth}"`);
			document.documentElement.style.setProperty(CSSStylePropertyHelper.HelperViewportHeight, `"${window.innerHeight}"`);
			document.documentElement.style.setProperty(
				CSSStylePropertyHelper.HelperViewportAspectRatio,
				`"${(window.innerWidth / window.innerHeight).toFixed(2)}"`
			);
		});

		resizeObserver.observe(document.documentElement);
	}
}

export const breakpointWidgetController = new BreakpointWidgetController();
